import { Flex } from '@approvalmax/ui/src/components';
import FieldEntry from 'pages/requestList/components/FieldEntry';
import { memo } from 'react';

import FieldEntryWrapper from '../../../../../components/FieldEntryWrapper/FieldEntryWrapper';
import PreviewSection from '../../../../../components/previewSection/PreviewSection';
import SectionSeparator from '../../../../../components/SectionSeparator/SectionSeparator';
import { messages } from './PaymentDetailsSection.messages';
import { PaymentDetailsSectionProps } from './PaymentDetailsSection.types';

export const PaymentDetailsSection = memo<PaymentDetailsSectionProps>((props) => {
    const {
        contactData: { paymentDetails, accountNumber },
    } = props;
    const hasFilledValue = paymentDetails || accountNumber;

    if (!hasFilledValue) {
        return null;
    }

    return (
        <>
            <PreviewSection header={messages.header.toUpperCase()}>
                {accountNumber && (
                    <FieldEntryWrapper>
                        <FieldEntry title={messages.accountNo} value={accountNumber} />
                    </FieldEntryWrapper>
                )}

                {paymentDetails && (
                    <Flex wrap>
                        <FieldEntryWrapper>
                            <FieldEntry title={messages.bankAccountName} value={paymentDetails.bankAccountName} />
                        </FieldEntryWrapper>

                        <FieldEntryWrapper>
                            <FieldEntry title={messages.bsb} value={paymentDetails.bankBranchIdentifier} />
                        </FieldEntryWrapper>

                        <FieldEntryWrapper>
                            <FieldEntry title={messages.bankAccountNumber} value={paymentDetails.bankAccountNumber} />
                        </FieldEntryWrapper>

                        <FieldEntryWrapper>
                            <FieldEntry title={messages.statement} value={paymentDetails.statementText} />
                        </FieldEntryWrapper>
                    </Flex>
                )}
            </PreviewSection>

            <SectionSeparator />
        </>
    );
});
